<footer class="footer">
  <div class="container">
    <!-- Top Section: Contact and Navigation -->
    <div class="footer-top">
      <div class="footer-content">
        <!-- Contact Section -->
        <div class="contact-section">
          <h3>Stay in touch</h3>
          <div class="contact-list">
            <div class="contact-item">
              <span class="contact-label">General enquiries:</span>
              <a href="mailto:info&#64;collective-energy.africa" class="contact-link">info&#64;collective-energy.africa</a>
            </div>
            <div class="contact-item">
              <span class="contact-label">Technical support:</span>
              <a href="mailto:service&#64;collective-energy.africa" class="contact-link">service&#64;collective-energy.africa</a>
            </div>
            <div class="contact-item">
              <span class="contact-label">End-of-life & take-back requests:</span>
              <a href="mailto:takeback&#64;collective-energy.africa" class="contact-link">takeback&#64;collective-energy.africa</a>
            </div>
          </div>
        </div>

        <!-- Navigation Sections -->
        <div class="navigation-sections">
          <!-- Products -->
          <div class="nav-section">
            <h4>Product</h4>
            <ul class="nav-links">
              <li><a href="https://www.collective-energy.africa/products/batteries">Batteries</a></li>
              <li><a href="https://www.collective-energy.africa/products/inverters">Inverters</a></li>
            </ul>
          </div>

          <!-- Services -->
          <div class="nav-section">
            <h4>Services</h4>
            <ul class="nav-links">
              <li><a href="https://www.collective-energy.africa/services/ci-solutions">Commercial & industrial solutions</a></li>
              <li><a href="https://www.collective-energy.africa/services/ev-charging">EV charging solutions</a></li>
              <li><a href="https://www.collective-energy.africa/services/technical-support">Technical support</a></li>
              <li><a href="https://www.collective-energy.africa/services/trainings-events">Trainings & events</a></li>
              <li><a href="https://www.collective-energy.africa/services/end-of-life">End-Of-Life</a></li>
            </ul>
          </div>

          <!-- About Us -->
          <div class="nav-section">
            <h4>About us</h4>
            <ul class="nav-links">
              <li><a href="https://www.collective-energy.africa/about-us">Company</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Divider Line -->
    <div class="footer-divider"></div>

    <!-- Bottom Section: Logo and Copyright -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <!-- Logo and Company Name -->
        <div class="logo-section">
          <a href="https://www.collective-energy.africa/" class="logo">
            <img src="assets/MENU/CE_white.png" alt="Collective Energy Africa" class="logo-img">
          </a>
          <span class="group-name">Collective Energy Group</span>
        </div>

        <!-- Copyright -->
        <div class="copyright">
          <span>All Rights Reserved. ©2025</span>
        </div>
      </div>
    </div>
  </div>
</footer>
